import React from "react";
import Button from "@material-ui/core/Button";
import { languages } from "../../constants/languages";
import CreateIcon from "@material-ui/icons/Create";
import IconButton from "@material-ui/core/IconButton";

const EditTeamButton = props =>
  props.team ? (
    <IconButton aria-label="Change" onClick={props.toggleDialog} style={{ padding: 5 }}>
      <CreateIcon />
    </IconButton>
  ) : (
    <Button
      variant="outlined"
      color="default"
      size="small"
      onClick={props.toggleDialog}
    >
      {languages.formatString(
        languages.teams.addTeam,
        props.tournament.individualPlayers
          ? languages.teams.playerLow
          : languages.results.teamLow
      )}
    </Button>
  );

export default EditTeamButton;
